var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEr2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9221 1.92295C15.1469 1.74173 15.4838 1.8512 15.5592 2.12997L16.4548 5.44156C16.5039 5.62321 16.673 5.74606 16.8609 5.73664L20.2872 5.56502C20.5756 5.55057 20.7838 5.83717 20.6809 6.107L19.459 9.31253C19.3919 9.48836 19.4565 9.68713 19.6141 9.78998L22.4869 11.665C22.7287 11.8229 22.7287 12.1771 22.4869 12.335L19.6141 14.21C19.4565 14.3129 19.3919 14.5116 19.459 14.6875L20.6809 17.893C20.7838 18.1628 20.5756 18.4494 20.2872 18.435L16.8609 18.2634C16.673 18.2539 16.5039 18.3768 16.4548 18.5584L15.5592 21.87C15.4838 22.1488 15.1469 22.2583 14.9221 22.0771L12.2511 19.9243C12.1046 19.8062 11.8956 19.8062 11.749 19.9243L9.07803 22.0771C8.85318 22.2583 8.51627 22.1488 8.44089 21.87L7.54534 18.5584C7.49622 18.3768 7.32713 18.2539 7.1392 18.2634L3.71294 18.435C3.42453 18.4494 3.2163 18.1628 3.31917 17.893L4.54116 14.6875C4.60819 14.5116 4.5436 14.3129 4.38603 14.21L1.51326 12.335C1.27143 12.1771 1.27143 11.8229 1.51325 11.665L4.38603 9.78998C4.5436 9.68713 4.60819 9.48836 4.54116 9.31253L3.31917 6.107C3.2163 5.83717 3.42453 5.55057 3.71294 5.56502L7.1392 5.73664C7.32713 5.74606 7.49622 5.62321 7.54534 5.44156L8.44089 2.12997C8.51627 1.8512 8.85318 1.74173 9.07803 1.92295L11.749 4.07569C11.8956 4.19378 12.1046 4.19378 12.2511 4.0757L14.9221 1.92295Z",
    stroke: "#35383D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z",
    stroke: "#35383D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr2);
export default __webpack_public_path__ + "static/media/er-2.e66b1b7e6e1c8052c1b3ea8964541f8d.svg";
export { ForwardRef as ReactComponent };